import {
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
} from '@angular/core';
import { PieChartModule } from '@swimlane/ngx-charts';
import { NoDataContainerComponent } from '../../no-data-container/no-data-container.component';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'app-general-chart',
  templateUrl: './general-chart.component.html',
  styleUrls: ['./general-chart.component.css'],
  imports: [PieChartModule, NoDataContainerComponent, TranslocoPipe],
})
export class GeneralChartComponent implements OnInit, OnChanges {
  @Input() chartTitle = 'Logro promedio';
  @Input() resultPercentage: any;
  approvalPercentage: any;
  @Input() score!: string;
  @Input() colorScheme: { domain: string[] } = {
    domain: ['#5072ff', '#EDF3FF'],
  };
  @Input() isFilterOpen = false;

  constructor() {}

  ngOnInit(): void {
    this.updateApprovalPercentage();
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes.resultPercentage) this.updateApprovalPercentage();
  }
  /**
   * Updates the approval percentage based on resultPercentage data.
   *
   * This function checks if resultPercentage is available and sets the approvalPercentage property accordingly.
   * If resultPercentage is available and contains data, update approvalPercentage.
   */
  private updateApprovalPercentage() {
    if (this.resultPercentage && this.resultPercentage.length > 0) {
      this.approvalPercentage = this.resultPercentage[0].value;
    }
  }
}
